import { useEffect, useRef } from 'react';
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { tldAlternativesApiClient } from '../Components/TldAlternativesWithPrice/TldAlternativesWithPrice.apiClient';
import { DomainSearchGateModule } from '../module/domainSearchGate.module';
const toBiSuggestions = (recommendations, inHeroCard) => recommendations.map(rec => ({
  domain: rec.domain || '',
  isPremiumDomain: rec.premium || false,
  inHeroCard
}));
const stringifySuggestions = suggestions => JSON.stringify(suggestions.map(sug => ({
  domain: sug.domain,
  isPremium: sug.isPremiumDomain,
  in_hero_card: sug.inHeroCard
})));
export const useResultsPageOfferingsBi = _ref => {
  var _recommendations$;
  let recommendations = _ref.recommendations,
    isLoading = _ref.isLoading,
    _ref$includeHeroCardO = _ref.includeHeroCardOffers,
    includeHeroCardOffers = _ref$includeHeroCardO === void 0 ? false : _ref$includeHeroCardO,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    biError = _ref.biError,
    biErrorSubtype = _ref.biErrorSubtype;
  useEffect(() => {
    if (biError) {
      DomainSearchGateModule.internals.bi.onResultsPageError == null || DomainSearchGateModule.internals.bi.onResultsPageError({
        errorType: biError,
        errorSubtype: biErrorSubtype
      });
    }
  }, [biError, biErrorSubtype]);
  const isExactMatchHero = ((_recommendations$ = recommendations[0]) == null ? void 0 : _recommendations$.label) === RecommendationLabel.EXACT_MATCH;
  const hero = includeHeroCardOffers || isExactMatchHero ? recommendations[0] : undefined;
  const list = hero ? recommendations.slice(1) : recommendations;
  const heroDomain = includeHeroCardOffers ? (hero == null ? void 0 : hero.domain) ?? '' : '';
  const isHeroAltsEnabled = Boolean(heroDomain);
  const _tldAlternativesApiCl = tldAlternativesApiClient.hooks.useTldAlternatives({
      heroDomain
    }, isHeroAltsEnabled, {
      useErrorBoundary: false
    }),
    heroAltsData = _tldAlternativesApiCl.data,
    heroAltsError = _tldAlternativesApiCl.error;
  const heroAlternatives = (heroAltsData == null ? void 0 : heroAltsData.alternatives) ?? [];
  const isHeroAltsSettled = !isHeroAltsEnabled || heroAltsData !== undefined || heroAltsError !== null;
  const lastFiredResultsLoadKeyRef = useRef('');
  const pageRef = useRef(0);
  const reportedCountRef = useRef(0);
  const searchKeyRef = useRef(undefined);
  useEffect(() => {
    var _recommendations$2;
    if (!enabled || isLoading || recommendations.length === 0) {
      return;
    }
    if (!isHeroAltsSettled) {
      return;
    }
    const suggestions = hero ? [...toBiSuggestions([hero], true), ...toBiSuggestions(heroAlternatives, true), ...toBiSuggestions(list, false)] : toBiSuggestions(recommendations, false);
    const searchKey = (_recommendations$2 = recommendations[0]) == null ? void 0 : _recommendations$2.domain;
    if (searchKey !== searchKeyRef.current) {
      searchKeyRef.current = searchKey;
      pageRef.current = 0;
      reportedCountRef.current = 0;
    }
    const resultsKey = suggestions.map(s => `${s.domain}:${s.inHeroCard ? 1 : 0}`).join(',');
    if (resultsKey !== lastFiredResultsLoadKeyRef.current) {
      lastFiredResultsLoadKeyRef.current = resultsKey;
      const isNewPage = recommendations.length > reportedCountRef.current;
      const pageSuggestions = isNewPage && pageRef.current > 0 ? toBiSuggestions(recommendations.slice(reportedCountRef.current), false) : suggestions;
      if (isNewPage) {
        pageRef.current += 1;
        reportedCountRef.current = recommendations.length;
      }
      DomainSearchGateModule.internals.bi.onResultsPageLoad == null || DomainSearchGateModule.internals.bi.onResultsPageLoad({
        type: 'suggestions',
        suggestions: pageSuggestions,
        pageNumber: pageRef.current || 1,
        hero_card_offers: includeHeroCardOffers ? stringifySuggestions(toBiSuggestions(heroAlternatives, true)) : undefined
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, isLoading, recommendations.length, includeHeroCardOffers, isExactMatchHero, isHeroAltsSettled, heroAlternatives.length]);
};
//# sourceMappingURL=useResultsPageOfferingsBi.js.map